import PropTypes from 'prop-types';
import React, { useEffect, memo } from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { Map } from 'immutable';
import { push } from 'connected-react18-router';

import config from '../config';
import { showError } from '../utils/MessagePopup';
import connectOptions, { mergeProps } from '../utils/connectOptions';
import { Browse } from '../components/Browse';
import { isResearcher } from '../utils/checkPermissions';
import BrowseRouting from '../routing/BrowseRouting';
import { usePopupContext } from '../contexts/PopupContext';

const tabs = config.tabs.get('browse');

const BrowseContainer = ({ tabs, push, user }) => {
  const { openPopup, closePopup } = usePopupContext();

  const hasAccess = () => {
    if (!user) return false;

    return !isResearcher(user.getIn(['roles', 0, 'slug'], null));
  };

  useEffect(() => {
    if (!hasAccess()) {
      showError(openPopup, config.permisionError, () => {
        push('/');
        closePopup();
      });
    }
  }, [openPopup, closePopup, push]);

  if (!hasAccess()) return null;

  return (
    <>
      <Helmet title="Browse Page" />
      <Browse tabs={tabs}>
        <BrowseRouting />
      </Browse>
    </>
  );
};

BrowseContainer.propTypes = {
  push: PropTypes.func.isRequired,
  tabs: PropTypes.instanceOf(Map).isRequired,
};

function mapStateToProps(state) {
  return {
    tabs,
    user: state.auth.get('user', null),
  };
}

export { BrowseContainer };
export default connect(mapStateToProps, { push }, mergeProps, connectOptions)(memo(BrowseContainer));
